import { divWrapperFor } from '../../utils/wrapperFor';

export const Exception = divWrapperFor('exception', ['alert']);
export const ExceptionContainer = divWrapperFor('exception__container', ['alert']);
export const ExceptionHeader = divWrapperFor('exception__header');
export const ExceptionMessage = divWrapperFor('exception__message');
export const ExceptionCode = divWrapperFor('exception__code');
